import React from "react";
import { useCopies } from "shared/hooks/useCopies";

export function LicenseCap(props: {
  licenseCap?: string | number;
  unlimitedLicenseCap?: boolean;
  assigned: string | number;
}) {
  const copies = useCopies();
  if (props.licenseCap === "-1" || props.unlimitedLicenseCap) {
    return (
      <span className="maxLicenseCap">
        {copies.get("info.assigned.licenses.unlimited", {
          0: props.assigned
        })}
      </span>
    );
  }
  return (
    <React.Fragment>
      {props.licenseCap && (
        <span className="maxLicenseCap">
          {copies.get("info.assigned.licenses", {
            0: props.assigned,
            1: props.licenseCap
          })}
        </span>
      )}
    </React.Fragment>
  );
}
